var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"nes-badge is-splited",staticStyle:{"font-family":"hyper"}},[_c('span',{staticClass:"is-primary"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"is-success"},[_vm._v(_vm._s(_vm.level)+" %")])])])}
var staticRenderFns = []

export { render, staticRenderFns }